import type {
    FC
} from "react";
import type IQuestionnaireTitleProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    QuestionnaireItemPartContentProps
} from "../../type";
import {
    withQuestionnaireItemContext
} from "../../context";
import Text from "../../../text";

const QuestionnaireTitleContent: FC<QuestionnaireItemPartContentProps<IQuestionnaireTitleProps>> = ({
    customTheme: customThemeProp,
    itemContext,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        title: titleDynamicStyle
    } = useStyles({
        spaces
    });

    return <Text
        {...props}
        variant="titleMediumSize"
        customTheme={customTheme}
        id={itemContext.titleId}
        style={[
            style,
            stylesheet.title,
            titleDynamicStyle
        ]}
        color="high"
    >
        {children ?? itemContext.item.title}
        {
            itemContext.item.isRequired || children ?
                null
            :
                <Text
                    customTheme={customTheme}
                    variant="bodySmallSize"
                    color="low"
                >
                    {`\n${localize("questionnaire-optional")}`}
                </Text>
        }
    </Text>;
};
export default withQuestionnaireItemContext("Title", QuestionnaireTitleContent);
